export const arr  =[
    {LinkImg:"../c1.jpg"},
    {LinkImg:"../c2.jpg"},
    {LinkImg:"../c3.jpg"},
    {LinkImg:"../c4.jpg"},
    {LinkImg:"../c5.jpg"},
    {LinkImg:"../c6.jpg"},
    {LinkImg:"../c7.jpg"},
    {LinkImg:"../c9.jpg"},
    {LinkImg:"../c99.jpg"},
    {LinkImg:"../c77.jpg"},
  
    {LinkImg:"../c404.png"},
]

 